import React from "react";
import { useTranslation } from "react-i18next";
import { RelaySettingsModel } from "@shared/ui";

interface IRelaysSettingsSettingsProps {
  settings?: RelaySettingsModel;
  saveRelaysSettings: (key: keyof RelaySettingsModel, value: string) => void;
}
const RelaysSettings: React.FC<IRelaysSettingsSettingsProps> = ({
  settings,
  saveRelaysSettings,
}) => {
  const { t } = useTranslation();
  if (!settings) return null;
  const switches: { [key: string]: number } = {
    A: 8,
    B: 0,
    C: 7,
    D: 9,
  };

  return (
    <div className="form-wrapper settings-form">
      <div className="input-wrapper">
        <label>{t("relaySettings.labels.switch")}</label>
        <select
          onChange={(e) => saveRelaysSettings("channel", e.target.value)}
          value={settings?.channel ?? 0}
          defaultValue={0}
        >
          {Object.keys(switches).map((k) => (
            <option value={switches[k]}>{k}</option>
          ))}
        </select>
      </div>

      <div className="input-wrapper">
        <label>{t("relaySettings.labels.pin")}</label>
        <input
          type="number"
          value={settings?.pin ?? ""}
          onChange={(e) => saveRelaysSettings("pin", e.target.value)}
        />
      </div>

      <div className="input-wrapper">
        <label>{t("relaySettings.labels.value")}</label>
        <input
          type="number"
          value={settings?.value ?? ""}
          onChange={(e) => saveRelaysSettings("value", e.target.value)}
        />
      </div>
    </div>
  );
};

export default RelaysSettings;
